import {Empresa, EmpresaTableColumn, EmpresaTableSources} from "../models";
import {formatValue, putTableRowActionValue, TableRow, TableValueType} from "../../shared";

export function resolveEmpresaTableCellValue(
  empresa: Empresa,
  column: EmpresaTableColumn,
): string | string[] {
  const names = column.name.split('.');
  if (names.length > 1) {
    let os: any[] = [];

    switch (names[0]) {
      case 'contactos':
        break;
    }

    const vs: string[] = [];
    let v: string[];
    const attrs = names[names.length - 1].split('+');
    for (const o of os) {
      v = [];
      for (const attr of attrs) {
        if (!o || !o.hasOwnProperty(attr)) {
          continue;
        }
        v.push(formatValue(o[attr], column.literalFormat));
      }
      vs.push(v.join(' '));
    }
    return column.type === TableValueType.LIST ? vs : vs.join(' ');
  }
  return formatValue(empresa[column.name], column.literalFormat);
}

export function createEmpresaTableRow(
  empresa: Empresa,
  columns: EmpresaTableColumn[],
  sources: EmpresaTableSources
): TableRow {
  const row: TableRow = {
    __source__: empresa
  };
  let v: any;
  for (const column of columns) {
    switch (column.type) {
      case TableValueType.ACTION:
        row[column.name] = putTableRowActionValue(column, empresa, sources);
        if(column.actions){
          const subActions = [];
          for(const act of column.actions){
            const subCol = putTableRowActionValue(act, empresa, sources);
            if(subCol)
              subActions.push(subCol);
          }
          row[column.name].actions = subActions;
        }
        break;
      case TableValueType.LIST:
      case TableValueType.LITERAL:
        row[column.name] = resolveEmpresaTableCellValue(
          empresa,
          column
        );
        break;
    }
  }
  return row;
}
